import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClientService } from '../../../../services/httpClient/httpclient.service';

@Component({
  selector: 'app-kv-json-form-schema',
  templateUrl: './kv-json-form-schema.component.html',
  styleUrls: ['./json-schema-form.component.css']
})
export class KvJsonFormSchemaComponent {

  mySchema: any = {
    properties: {},
    required: [],
    order: []
  };
  myModel: any = {};
  formValue: any;

  @Input() formData: any;

  // Endpoint per recupero form-schema, se questo non già presente in input
  @Input() endPoint: string;

  @Input() readOnly: boolean = false;

  @Output() formSubmitted: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClientService) {

  }

  ngOnInit(): void {
    if (!this.formData) {
      this.http.get(this.endPoint).subscribe(res => {
        this.setForm(res);
      });
    } else {
      this.setForm(this.formData);
    }
  }

  setForm(data: any) {
    // Set Form Schema
    this.mySchema = {
      properties: {...data.form_schema.properties},
      required: data.form_schema.required ? [...data.form_schema.required] : []
    };
    if (data.form_schema.order) {
      Object.assign(this.mySchema, {order: data.form_schema.order});
    }
    if (data.form_schema.fieldsets) {
      Object.assign(this.mySchema, {fieldsets: data.form_schema.fieldsets});
    }
    if (data.form_values) {
      // Set Model
      const formValues = {...data.form_values};

      for (let prop in this.mySchema.properties) {
        // Conversione eventuali date
        if (this.mySchema.properties[prop].widget === "calendar" && formValues[prop]) {
          formValues[prop] = new Date(formValues[prop]);
        }
        // In caso di Api (in caso venga richiesto in futuro)
        if (this.mySchema.properties[prop].url) {
          const url: string = this.mySchema.properties[prop].url;
          const paramToShow: string = this.mySchema.properties[prop].paramToShow;
          const paramValue: string = this.mySchema.properties[prop].paramValue;
          this.http.get(url).subscribe(res => {
            res.forEach(r => {
              formValues[prop].oneOf.push({
                "label": r[`${paramToShow}`],
                "value": r[`${paramValue}`]
              });
            });
          })
        }
        // Converti <br> in \n\n per i campi di tipo "html"
        if (this.mySchema.properties[prop].widget.id === "html" && formValues[prop]) {
          formValues[prop] = this.replaceBrWithNewlines(formValues[prop]);
        }
      }
      this.myModel = {...formValues};
    }

    /*
      Problema della proprietà di default del form_schema. Questa proprietà va a sovrascrivere i valori che invece voglio visualizzare con this.myModel.
      FIX: se sono presenti dei valori che voglio vedere (quindi se this.myModel è valorizzato) allora cancella le proprietà "default" dal form_schema
    */
    if(this.myModel && Object.keys(this.myModel).length !== 0){
      this.deleteDefaultFromProprieties();
    }
  }
  deleteDefaultFromProprieties(){
    for(let key in this.mySchema.properties){
      if(this.mySchema.properties[key] && this.mySchema.properties[key].default){
        if(key == "form"){
          if(this.mySchema.properties.form && this.mySchema.properties.form.default){
            for(let fieldForm of this.mySchema.properties.form.default){
              let valueRowFromModel = (this.myModel.form && this.myModel.form.length>0) ? this.myModel.form.find(x=>x.det_id == fieldForm.det_id) : null;
              if(valueRowFromModel && valueRowFromModel.det_row_value){
                //fix: non sostituiva bene i valori di default 28/02/2025
                //FIX: ripristinata la situazione precendente e ora non da errori, non mi spiego perchè
                fieldForm.det_row_value = valueRowFromModel.det_row_value;
                fieldForm.det_description = valueRowFromModel.det_description;
              }
            }
          }
        }
        else{
          delete this.mySchema.properties[key].default;
        }
      }
    }
  }
  getFormValue(formValue: any) {
    this.formValue = formValue;
  }

  validateForm(formValue: any) {
    let formIsValid = true;
    this.mySchema.required.forEach(requiredField => {
      if (!formValue[requiredField]) {
        formIsValid = false;
      }
    });
    return formIsValid;
  }

  replaceNewlinesWithBr(text: string): string {
    return text.replace(/\n\n<p>&nbsp;<\/p>/g, '').replace(/\n\n/g, '<br>');
  }

  replaceBrWithNewlines(text: string): string {
    return text.replace(/<br>/g, '\n\n');
  }

  submitForm() {
    if (!this.validateForm(this.formValue)) {
      console.log("il form non è valido")
      return;
    }

    // Sostituisci \n\n con <br> nei campi di tipo "html" per il nuovo widget introdotto per layout coupon
    for (let key in this.mySchema.properties) {
      if (this.mySchema.properties[key].widget.id === "html" && this.formValue[key]) {
        this.formValue[key] = this.replaceNewlinesWithBr(this.formValue[key]);
      }
    }

    this.myModel = this.formValue;
    this.formSubmitted.emit(this.myModel);
  }

  @Output() formClosed = new EventEmitter<void>();

  closeForm() {
    this.formClosed.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/kv-json-form-schema.component.ts